import { IFormTypes } from "../data/form-types";

export class FormTypes {
  static readonly BUSINESS = 'business';
  static readonly CHILD = 'sponsor-child';
  static readonly PARENT = 'sponsor-parent';
  static readonly PARTNER = 'sponsor-partner';
  static readonly SKILLED = 'skilled-visa';
  static readonly STUDY = 'study';
  static readonly WORK = 'work';
  static readonly VISIT = 'visit';
  static readonly EMPLOYER_TEMP = 'employerTemp';
  static readonly EMPLOYER_PERM = 'employerPerm';
  static readonly GENERIC = 'enquiry';
  static readonly BUSINESS_ENQUIRY = 'businessEnquiry';
  static readonly APPEAL_REFUSE = 'appealRefuse';
  static readonly APPEAL_CANCEL = 'appealCancel';
  static readonly GENERAL = 'generic';
  static readonly VEVO = 'vevo';
  static readonly VEVO_MYSELF = 'vevo-myself';
  static readonly VEVO_EMPLOYEE = 'vevo-employee';
  static readonly VEVO_CONTRACT = 'vevo-contract';

  // Helper method to get all form types as an object (for backwards compatibility)
  static getAll(): IFormTypes {
    return {
      business: this.BUSINESS,
      child: this.CHILD,
      parent: this.PARENT,
      partner: this.PARTNER,
      skilled: this.SKILLED,
      study: this.STUDY,
      work: this.WORK,
      visit: this.VISIT,
      employerTemp: this.EMPLOYER_TEMP,
      employerPerm: this.EMPLOYER_PERM,
      generic: this.GENERIC,
      businessEnquiry: this.BUSINESS_ENQUIRY,
      appealRefuse: this.APPEAL_REFUSE,
      appealCancel: this.APPEAL_CANCEL,
      general: this.GENERAL,
      vevoMyself: this.VEVO_MYSELF,
      vevoEmployee: this.VEVO_EMPLOYEE,
      vevoContract: this.VEVO_CONTRACT
    };
  }
}